import React, { useState, useEffect } from "react";
import { db } from '../firebase/firestore';
import { collection, getDocs, orderBy, query } from "firebase/firestore";

const TermsPage = () => {
  const [terms, setTerms] = useState([]);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const q = query(collection(db, "terms"), orderBy("createdAt", "asc"));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setTerms(data);
      } catch (err) {
        console.error("Ошибка загрузки Terms:", err);
      }
    };
    fetchTerms();
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center">Terms and Conditions</h1>
      {terms.length ? terms.map((term, index) => (
        <section key={term.id} className="mb-6">
          <h2 className="text-xl font-semibold mb-2">{index + 1}. {term.title}</h2>
          <p className="text-gray-700">{term.content}</p>
        </section>
      )) : <p className="text-gray-500">No terms available</p>}
    </div>
  );
};

export default TermsPage;
